import { Component, OnInit, OnDestroy } from "@angular/core";
import { ModalService } from "../../modal/services/modal.service";
import { Store } from "@ngrx/store";
import { IAppState } from "src/app/store/states/app";
import { Subscription, combineLatest } from "rxjs";
import {
  selectAuthenticatedAdmin,
  selectAuthenticatedUserMe,
  selectManageOwnAuctions,
} from "src/app/store/selectors";
import { ROUTES_CONFIG } from "src/app/config";
import { Router } from "@angular/router";
import { Logout } from "src/app/store/actions/user";

@Component({
  selector: "app-profile-navbar",
  templateUrl: "./profile-navbar.component.html",
  styleUrls: ["./profile-navbar.component.scss"],
})
export class ProfileNavbarComponent implements OnInit, OnDestroy {
  private storeSubscription: Subscription;

  private userInfo;
  private userCanManageAuction;
  private userIsAdmin: boolean;

  private readonly profileRoutes = [
    {
      route:
        "/" +
        ROUTES_CONFIG.PROFILE_MY_AUCTIONS.PARENT +
        ROUTES_CONFIG.PROFILE_MY_AUCTIONS.ROUTE,
      title: "ჩემი აუქციონი",
    },
    {
      route:
        "/" +
        ROUTES_CONFIG.PROFILE_PERSONAL_INFORMATION.PARENT +
        ROUTES_CONFIG.PROFILE_PERSONAL_INFORMATION.ROUTE,
      title: "პირადი ინფორმაცია",
    },
    // {
    //   route: '/' + ROUTES_CONFIG.PROFILE_BANK_DETAILS.PARENT + ROUTES_CONFIG.PROFILE_BANK_DETAILS.ROUTE,
    //   title: 'საბანკო რეკვიზიტები',
    // },
    {
      route:
        "/" +
        ROUTES_CONFIG.PROFILE_CHANGE_PASSWORD.PARENT +
        ROUTES_CONFIG.PROFILE_CHANGE_PASSWORD.ROUTE,
      title: "პაროლის შეცვლა",
    },
    // {
    //   route: '/' + ROUTES_CONFIG.PROFILE_FAVORITES.PARENT + ROUTES_CONFIG.PROFILE_FAVORITES.ROUTE,
    //   title: 'ფავორიტები',
    // },
    // {
    //   route: '/' + ROUTES_CONFIG.PROFILE_NOTIFICATIONS.PARENT + ROUTES_CONFIG.PROFILE_NOTIFICATIONS.ROUTE,
    //   title: 'შეტყობინებები',
    // },
    {
      route:
        "/" +
        ROUTES_CONFIG.PROFILE_TRANSACTION_HISTORY.PARENT +
        ROUTES_CONFIG.PROFILE_TRANSACTION_HISTORY.ROUTE,
      title: "ტრანზაქციების ისტორია",
    },
  ];

  constructor(
    private _store: Store<IAppState>,
    private modalService: ModalService,
    private router: Router,
  ) {
    this.storeSubscription = combineLatest(
      this._store.select(selectAuthenticatedUserMe),
      this._store.select(selectManageOwnAuctions),
      this._store.select(selectAuthenticatedAdmin),
    ).subscribe(([user, canManageOwnAuction, admin]) => {
      if (user) {
        this.userInfo = user;
        this.userCanManageAuction = canManageOwnAuction;
        this.userIsAdmin = admin;
      }
    });
  }

  ngOnInit() {}

  closeModal() {
    this.modalService.closePopup();
  }

  logout() {
    this._store.dispatch(new Logout({}));
    this.closeModal();
  }

  openModal(name: string) {
    this.modalService.load({ name });
  }

  get getUserInfo() {
    return this.userInfo ? this.userInfo : { first_name: "123" };
  }

  get getUserCanManageAuction() {
    return this.userCanManageAuction;
  }

  get getProfileRoutes() {
    return this.profileRoutes;
  }

  get userBalance() {
    return this.userInfo ? this.userInfo.balance : false;
  }

  get isUserAdmin() {
    return this.userIsAdmin;
  }

  get userFullName() {
    return `${this.getUserInfo.first_name} ${this.getUserInfo.last_name}`
      .toLowerCase()
      .replace(/\b[a-z](?=[a-z]{2})/g, (letter) => {
        return letter.toUpperCase();
      });
  }

  ngOnDestroy() {
    if (this.storeSubscription) {
      this.storeSubscription.unsubscribe();
    }
  }
}
